import React from 'react'
import { Edit } from 'react-admin'

import BroadcastersForm from './form'

const BroadcasterTitle = ({ record }) => {
  return <span>{`Broadcaster: ${record.nombre}`}</span>
}

export const BroadcastersEdit = (props) => (
  <Edit undoable={false} title={<BroadcasterTitle />} {...props}>
    <BroadcastersForm {...props} />
  </Edit>
)

export default BroadcastersEdit
